import { VARIATION_NAMES } from './Header';
import localeLink from './localeLink';
import loginLink from './loginLink';
import { t, getLanguage, languageMatches } from '../i18n';
export var LinkIdentifier = /*#__PURE__*/function (LinkIdentifier) {
  LinkIdentifier["LOGIN"] = "login";
  LinkIdentifier["LOGOUT"] = "logout";
  return LinkIdentifier;
}({});
/**
 * Default menu links for each header variation.
 * Apps can import this method into their app if they need to
 * extend the existing default list of menu links.
 */
export function defaultMenuLinks() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var deConsumer = options.deConsumer,
    subpath = options.subpath,
    _options$primaryDomai = options.primaryDomain,
    primaryDomain = _options$primaryDomai === void 0 ? '' : _options$primaryDomai,
    switchLocaleLink = options.switchLocaleLink,
    hideLoginLink = options.hideLoginLink,
    hideLogoutLink = options.hideLogoutLink,
    hideLanguageSwitch = options.hideLanguageSwitch,
    customLinksPassedIn = options.customLinksPassedIn;
  var isSpanish = languageMatches('es', getLanguage());
  var ffmLocalePath = isSpanish ? 'es_MX' : 'en_US';

  // NOTE: order matters here and links will be displayed in order added to the arrays
  var loggedOut = [];
  var loggedIn = [];

  // Links other than the ones inside this if should need to be explicitly hidden for their
  // respective variations. This means the language and login will show even if a custom set
  // of links is passed in.
  if (!customLinksPassedIn) {
    loggedIn.push({
      label: t('header.myApplicationsAndCoverage'),
      href: "".concat(primaryDomain, "/marketplace/auth/global/").concat(ffmLocalePath, "/myProfile#landingPage")
    });
    loggedIn.push({
      label: t('header.myProfile'),
      href: "".concat(primaryDomain, "/marketplace/auth/global/").concat(ffmLocalePath, "/myProfile#settings")
    });
  }
  if (!hideLanguageSwitch) {
    var _getLanguage;
    var locLink = localeLink(t, (_getLanguage = getLanguage()) !== null && _getLanguage !== void 0 ? _getLanguage : getLanguage(), subpath, switchLocaleLink);
    loggedOut.push(locLink);
    loggedIn.push(locLink);
  }
  if (!hideLoginLink) {
    var logLink = loginLink(t, deConsumer, primaryDomain);
    loggedOut.push(Object.assign({
      identifier: LinkIdentifier.LOGIN
    }, logLink));
  }
  if (!hideLogoutLink) {
    loggedIn.push({
      identifier: LinkIdentifier.LOGOUT,
      label: t('header.logout'),
      href: "".concat(primaryDomain || '', "/logout")
    });
  }
  var links = {};
  links[VARIATION_NAMES.LOGGED_OUT] = loggedOut;
  links[VARIATION_NAMES.LOGGED_IN] = loggedIn;
  return links;
}
export default defaultMenuLinks;